"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { Scrim } from "../Scrim/index.js";
import { popupHeaderVariants } from "./PopupHeader.variants.js";
import { PopupHeaderContext } from "./PopupHeaderContext.js";
const PopupHeader_Root_PopupHeaderRoot = /*#__PURE__*/ forwardRef(function({ className, size, dividerTop = false, inset = false, scrim = false, 'data-scroll-state': scrollState = 'static', children, ...props }, ref) {
    const { root } = popupHeaderVariants({
        size,
        dividerTop,
        inset,
        scrim
    });
    const domProps = cleanProps(props, Object.keys(popupHeaderVariants.variants));
    const inner = /*#__PURE__*/ jsx("div", {
        ref: ref,
        className: cn(root(), className),
        "data-scroll-state": scrollState,
        ...domProps,
        children: children
    });
    const contextValue = useMemo(()=>({
            scrim
        }), [
        scrim
    ]);
    return /*#__PURE__*/ jsx(PopupHeaderContext.Provider, {
        value: contextValue,
        children: scrim ? /*#__PURE__*/ jsx(Scrim, {
            isTop: true,
            children: inner
        }) : inner
    });
});
PopupHeader_Root_PopupHeaderRoot.displayName = 'PopupHeader.Root';
export { PopupHeader_Root_PopupHeaderRoot as PopupHeaderRoot };
